
import Product from './Business/Product';
import Dashboard from './Business/Dashboard';
import Project from './Business/Project';
import ContactInfo from './Business/ContactInfo';
import License from './Business/license';
import Gallery from './Business/Gallery';
import Login from './Business/Login';
import Text from './Business/Text';
import MainPage from './Business/MainPage';
import ArticleCategory from './Business/ArticleCategory';
import Article from './Business/Article';
import MapLocations from './Business/MapLocations';
import ContactMessages from './Business/ContactMessages';
import { CustomProvider } from 'rsuite';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

function App() {
  return (
    <CustomProvider>
      <BrowserRouter>
        <Routes>
          <Route path='/Dashboard' element={<Dashboard />} />
          <Route path='/Product' element={<Product />} />
          <Route path='/Project' element={<Project />} />
          <Route path='/ContactInfo' element={<ContactInfo />} />
          <Route path='/License' element={<License />} />
          <Route path='/MainPage' element={<MainPage />} />
          <Route path='/Gallery' element={<Gallery />} />
          <Route path='/Text' element={<Text />} />
          <Route path='/ArticleCategory' element={<ArticleCategory />} />
          <Route path='/Article' element={<Article />} />
          <Route path='/MapLocations' element={<MapLocations />} />
          <Route path='/ContactMessages' element={<ContactMessages />} />
          <Route path='/' element={<Login />} />
        </Routes>
      </BrowserRouter>
    </CustomProvider>
  );
}

export default App;
